export const useSettingsStore = defineStore("settingsStore", () => {
  // States

  const distance = ref(50);
  const histories = ref(null);

  return {
    histories,
    distance,
  };
});
